module.exports = __webpack_public_path__ + "img/banner.0b611324.png";